import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RestApiCall } from "../core/services/rest-api.service";
import { LoginResponse } from "../model";
import { md5 } from './md5';
import { Urls, googleConfig } from "../../environments/environment";
import { HttpParams } from "@angular/common/http";


@Injectable()
export class LoginService {

        private url: string = './assets/dummy/login.json';

        constructor(private restApi: RestApiCall) {
        }

        /**
         * login api call
         * @param f data object
         * @returns {Observable<any>}
         */
        loginApi(f: any): Observable<LoginResponse> {
                let url = Urls.final_url + 'login';
                let body = new HttpParams();
                body = body.set('username', f.value.username.trim());
                body = body.set('password', md5(f.value.password.trim()));
                return this.restApi.post(url, body);
        }

        /**
         * login api call
         * @param f data object
         * @returns {Observable<any>}
         */
        // signOut(): Observable<LoginResponse> {
        //         let url = Urls.final_url + 'signout';
        //         return this.restApi.get(url, null);
        // }

        signOut(userId): Observable<LoginResponse> {
                //logdebugger
                let url = googleConfig.logout.logoutUrl;
                let params = new HttpParams();
                params = params.append('userId', userId);
                return this.restApi.postSSO2(url, params);
        }

        fetchAgenciesUnderCity(cityid) {
                let url = Urls.final_url + 'cities/agencies';
                let params = new HttpParams();
                params = params.set('cityId', cityid);
                return this.restApi.get(url, params);
        }

        fetchAccountsUnderAgency(agencyId, cityId){
                let url = Urls.final_url + 'accountsForAgency';
                let params = new HttpParams();
                params = params.set('agencyId', agencyId);
                params = params.set('cityId', cityId);
                return this.restApi.get(url, params);
        }
        fetchGpsAgenciesUnderCity(gpsAgencyId, cityId) {
                let url = Urls.final_url + 'dashboard/login/account-for-agency';
                let params = new HttpParams();
                params = params.set('gpsAgencyId', gpsAgencyId);
                params = params.set('cityId', cityId);
                return this.restApi.get(url, params);
        }

        fetchAgenciesUnderRegion(regionId) {
                let url = Urls.final_url + 'dashboard/regions/agencies';
                let params = new HttpParams();
                params = params.set('regionId', regionId);
                return this.restApi.get(url, params);
        }

        getCityByAgency(agencyId: any) {
                const url = Urls.final_url + "dashboard/city/info-by-agency";
                let params = new HttpParams();
                params = params.set("agencyId", agencyId);
                return this.restApi.get(url, params);
        }



}
